import { render, staticRenderFns } from "./DeleteStepper.vue?vue&type=template&id=2b8e74ea&scoped=true"
import script from "./DeleteStepper.vue?vue&type=script&lang=js"
export * from "./DeleteStepper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8e74ea",
  null
  
)

export default component.exports